// src/shared/components/ui/RelativeTime.tsx
//
// Self-updating relative timestamp cell.
// Ticks every second so "30s ago" → "31s ago" without any parent re-render.
// Usage:  <RelativeTime value={row.created_at} />
//         <RelativeTime value={someDate} className="text-amber-400" />

import React, { useEffect, useState } from 'react'
import { timeAgo } from '@/utils/date'

interface Props {
  /** ISO string, Date object, or null/undefined → renders "—" */
  value?: string | Date | null
  className?: string
}

export default function RelativeTime({ value, className }: Props) {
  // dummy counter — triggers a re-render each tick
  const [, tick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => tick(n => n + 1), 1_000)
    return () => clearInterval(id)
  }, [])

  const raw   = value instanceof Date ? value.toISOString() : (value ?? undefined)
  const label = timeAgo(raw)
  const title = raw ? new Date(raw).toLocaleString() : undefined

  return (
    <span
      className={`font-mono text-xs tabular-nums text-neutral-400 ${className ?? ''}`}
      title={title}
    >
      {label}
    </span>
  )
}
